export default __webpack_public_path__ + "static/media/bg.6d22da0d.svg";